import { Link } from 'react-router';

import { Box, Row, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';
import { IProfessionalCardRating } from '../../interfaces';
import { ProfessionalRating } from '../ProfessionalRating';

interface IProfessionalNameRowProps {
  id: string;
  fullname: string;
  rating?: IProfessionalCardRating;
  isAvailable?: boolean;
}

export const ProfessionalNameRow = ({
  id,
  fullname,
  rating,
  isAvailable = true,
}: IProfessionalNameRowProps) => (
  <Row alignItems="center" gap={8} style={{ whiteSpace: 'nowrap', minWidth: 0 }}>
    <Text
      bold
      fontSize={20}
      opacity={isAvailable ? 1 : 0.5}
      style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        minWidth: 0,
        flexShrink: 1,
      }}
    >
      {fullname}
    </Text>

    {rating != null && (
      <Row alignItems="center" gap={8} style={{ flexShrink: 0 }}>
        <ProfessionalRating rating={rating} isAvailable={isAvailable} />

        <Box height={20} width={2} backgroundColor={Colors.neutral_600} />

        {isAvailable ? (
          <Link to={`/dashboard/professional/${id}`} style={{ textDecoration: 'none' }}>
            <Text bold color={Colors.secondary_500} fontSize={18}>
              Profile
            </Text>
          </Link>
        ) : (
          <Text bold color={Colors.secondary_200} fontSize={18}>
            Profile
          </Text>
        )}
      </Row>
    )}
  </Row>
);
